export const SEARCH_TERMS = ["title", "meta_title"];
export const inputFields = {
  testimonial: {
    type: "string",
    required: true,
    title: "Testimonial",
  },
  user: {
    type: "string",
    required: true,
    title: "User",
  },
};
export const initialValues = {
  testimonial: "",
  user: "",
};

export const view_all_table = [
  { name: "User", value: "user" },
  { name: "Testimonial", value: "testimonial" },
];
